export default "__VITE_PUBLIC_ASSET__2671574f__"